import { InputRules } from '@/types/inputs';
import { buildInputRulesObject } from '@/utils/buildInputRulesObject';
import { Box, Checkbox, FormControlLabel, FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

type SVCheckboxProps = {
  name: string;
  label: string;
  disabled?: boolean;
  rules?: InputRules;
};

export default function SVCheckbox({
  name,
  label,
  disabled,
  rules,
}: SVCheckboxProps) {
  const methods = useFormContext();
  const builtRulesObject = buildInputRulesObject(label, rules);

  return (
    <Controller
      control={methods.control}
      name={name}
      rules={builtRulesObject}
      render={({
        field: { value, onChange, onBlur },
        fieldState: { error },
      }) => (
        <Box sx={{ marginBottom: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                data-testid="checkbox-input"
                disabled={disabled}
                checked={value}
                onChange={onChange}
                onBlur={onBlur}
              />
            }
            label={label}
          />
          {error?.message && (
            <FormHelperText
              sx={{
                flex: 1,
                width: '100%',
                margin: 0,
                color: '#DD3929',
              }}>
              {error?.message}
            </FormHelperText>
          )}
        </Box>
      )}
    />
  );
}
